/**
 * @generated SignedSource<<db581129c92c68532847e127f2e8dc34>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateTeamInput = {
  description?: string | null | undefined;
  id: any;
  name: string;
};
export type EditTeamRouteUpdateTeamMutation$variables = {
  input: UpdateTeamInput;
};
export type EditTeamRouteUpdateTeamMutation$data = {
  readonly updateTeam: {
    readonly team: {
      readonly description: string | null | undefined;
      readonly id: any;
      readonly name: string;
    };
  };
};
export type EditTeamRouteUpdateTeamMutation = {
  response: EditTeamRouteUpdateTeamMutation$data;
  variables: EditTeamRouteUpdateTeamMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateTeamPayload",
    "kind": "LinkedField",
    "name": "updateTeam",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GraphQLTeam",
        "kind": "LinkedField",
        "name": "team",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EditTeamRouteUpdateTeamMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditTeamRouteUpdateTeamMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "fe733961e02fae5fd4720188b7e89ebf",
    "id": null,
    "metadata": {},
    "name": "EditTeamRouteUpdateTeamMutation",
    "operationKind": "mutation",
    "text": "mutation EditTeamRouteUpdateTeamMutation(\n  $input: UpdateTeamInput!\n) {\n  updateTeam(input: $input) {\n    team {\n      id\n      name\n      description\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "55e813e167b563dbf61ac4025e2c032a";

export default node;
